export default "__VITE_ASSET__Do6B5PLj__"